import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {PushNotificationPopupIntentEnum, USER_ACTION_ENUM} from '../notifications/UIMRequestPushNotificationController'
import {createDivIn, createImgIn, createParagraphIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'

export class UIMRequestPushNotificationOnLoadHomePagePopup extends ViewPopup {
    constructor() {
        super({key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.title'},
            undefined,
            () => {
                UIMDeviceHandler.requestNotificationPermission()
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_ACCEPTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnLoadHomePage,
                })
                StorageWrapper.setPushNotificationRequestStatus(true)
            },
            () => {
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_REJECTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnLoadHomePage,
                })
            },
            false,
            {
                checkButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.checkButtonCustomContent'},
                xButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.xButtonCustomContent'},
            })

        this.createBody()

        this.stylePopup()
        this.show()
    }

    private createBody() {
        const perksContainer = createDivIn(this.body, 'notification-preferences-container')

        this.createPreferenceItem(perksContainer, LobbyImage.Friends, {key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.friendRequests'})
        this.createPreferenceItem(perksContainer, LobbyImage.ProfileMemberships, {key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.leaderboardUpdates'})
        this.createPreferenceItem(perksContainer, LobbyImage.ColonistCoin, {key: 'strings:homePage.popups.requestPushNotificationOnLoadHomePage.exclusiveOffers'})
    }

    // eslint-disable-next-line class-methods-use-this
    private createPreferenceItem(container: HTMLElement, icon: LobbyImage, text: TranslationObject) {
        const itemContainer = createDivIn(container, 'notification-preference-item')

        const iconContainer = createDivIn(itemContainer, 'notification-preference-icon')
        createImgIn(iconContainer, icon, 'notification-preference-icon-img')

        const textContainer = createDivIn(itemContainer, 'notification-preference-text')
        createParagraphIn(textContainer, text, 'notification-preference-text-content')
    }

    private stylePopup() {
        this.body.classList.add('request-push-notification-body')
        this.xButton.classList.add('btn_ghost')
        this.xButton.style.maxWidth = 'unset'
        this.checkButton.style.maxWidth = 'unset'
    }
}
